import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { startSxpProxy } from '../../utils/api'
import { ADMIN_PROJECT_ID } from '../../utils/constants'
import { OrganizationIntent } from '../administration/constants'
import ProvenanceView from '../../components/ProvenanceView'
import { useTheme } from '@emotion/react'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import { Box, Button, IconButton, TextField, Tooltip } from '@mui/material'
import { ColDef, ITextFilterParams } from 'ag-grid-community'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import { radiologyEndPoint } from '../Radiology/RadiologyEndPoints'
import { radiologyColor } from '../Radiology/Utils/RadiologyColors'
import {
  activeText,
  inactiveText,
  provenanceCreate,
  provenanceUpdate,
  radiology,
} from '../Radiology/Constants/constants'
import { DeleteOutlined } from '@mui/icons-material'
import KeycloakService from '../../utils/keycloakService'
import { SUPER_ADMIN_DELETE } from '../../utils/roles'
import { menuValues } from '../lms/constants'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined'
import { Archive } from '../lms/components/admin/Archive'
import { DeleteConfirmationDialog } from '../lms/components/admin/DeleteConfirmationDialog'
import EditIcon from '@mui/icons-material/Edit'
import { active, lab } from '../lms/models'
import { activeOptions } from './constants'
const styles = () => ({
  partnerDasboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    height: '98%',
    padding: '1%',
    gap: 20,
  },
  partnerDasboardTableContainer: {
    width: '100%',
    height: '100%',
  },
  partnerDasboardCreateBtn: {
    textTransform: 'capitalize',
    backgroundColor: radiologyColor?.steelBlue,
  },
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  redCircleOutIcon: {
    color: radiologyColor?.red,
  },
  greenCircleOutIcon: {
    color: radiologyColor?.green,
  },
  calendarMonthIcon: {
    height: '18px',
    width: '20px',
    color: '#183f7c',
  },
  globalSearchInput: {
    minWidth: '300px !important',
    backgroundColor: 'white !important',
    fontSize: '10px',
    padding: '0px !important',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#aeafb5',
      },
      '&:hover fieldset': {
        borderColor: '#aeafb5 !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#aeafb5 !important',
        borderWidth: '1px !important',
      },
    },
    '& .MuiInputBase-input': {
      padding: '4px 10px',
    },
    '& .MuiInputBase-adornedStart': {
      padding: '0px !important',
    },
  },
  MedAgDataGridInput: {
    border: '1px solid #aeafb5',
    borderRadius: 5,
    padding: '5px !important',
    background: 'white',
  },
})

const Organization = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const [organizations, setOrganizations] = useState([])
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false)
  const [organization, setOrganization] = useState<any>({})
  const [status, setStatus] = useState(activeOptions?.[0]?.value)
  const [searchTerm, setSearchTerm] = useState('')
  const filteredOrganizations = organizations?.filter((item: any) => {
    const isStatusMatch =
      status === active
        ? item?.status !== inactiveText
        : item?.status === inactiveText

    const target = [
      item?.id,
      item?.name,
      item?.mobile_number,
      item?.odoo_partner_id,
      item?.date_changed,
    ]
      ?.join(' ')
      ?.toLowerCase()

    const isSearchMatch = target?.includes(searchTerm?.toLowerCase())

    return isStatusMatch && isSearchMatch
  })

  const getOrganizations = () => {
    setLoading(true)
    startSxpProxy(
      ADMIN_PROJECT_ID,
      OrganizationIntent?.getAllOrganizationForAdmin,
      {}
    )
      .then(async (data) => {
        if (data?.data?.organization?.length > 0) {
          setOrganizations(data?.data?.organization)
          setLoading(false)
        } else {
          setOrganizations([])
          setLoading(false)
        }
      })
      .catch(() => {
        setOrganizations([])
        setLoading(false)
      })
  }

  const handleEdit = (id: any) => {
    navigate(`${radiologyEndPoint?.edit}/${id}`)
  }
  const RenderCreatedBy = (params: any) => {
    return (
      <ProvenanceView
        date={params?.data?.date_created}
        name={params?.data?.created_by}
        mode={provenanceCreate}
      />
    )
  }

  const RenderUpdatedBy = (params: any) => {
    return (
      <ProvenanceView
        date={params?.data?.date_changed}
        name={params?.data?.updated_by}
        mode={provenanceUpdate}
      />
    )
  }

  const handleDeleteDialogOpen = (data: any) => {
    setDeleteDialog(true)
    setOrganization(data)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialog(false)
    setOrganization(null)
  }
  const renderEditActions = (params: any) => {
    return (
      <div className='set-action-icons'>
        {params?.data?.status?.toLowerCase() === activeText ? (
          <IconButton
            title='Archive'
            size='small'
            className={classes?.calendarMonthIcon}
            onClick={() => {
              Archive(params?.data, organizations, menuValues?.Partner)
              setOrganization(params?.data)
            }}
            disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
          >
            <ArchiveOutlinedIcon fontSize='small' />
          </IconButton>
        ) : (
          <IconButton
            title='Un-Archive'
            size='small'
            className={classes?.calendarMonthIcon}
            onClick={() => {
              Archive(params?.data, organizations, menuValues?.Partner)
              setOrganization(params?.data)
            }}
            disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
          >
            <UnarchiveOutlinedIcon fontSize='small' />
          </IconButton>
        )}
        <IconButton
          title='Delete'
          className={classes?.calendarMonthIcon}
          onClick={() => handleDeleteDialogOpen(params?.data)}
          disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
        >
          <DeleteOutlined />
        </IconButton>
        <Tooltip title='Edit Doctor'>
          <IconButton
            onClick={() => handleEdit(params?.data?.id)}
            sx={{ padding: 'unset !important' }}
          >
            <EditIcon className={classes?.calendarMonthIcon} />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  const FilterActions = () => {
    const navigateCreate = () => {
      navigate(radiologyEndPoint?.createRefferedOut)
    }
    return (
      <Button
        variant='contained'
        size='small'
        className={classes?.partnerDasboardCreateBtn}
        onClick={navigateCreate}
      >
        Create
      </Button>
    )
  }

  const columnDefs: ColDef[] = [
    {
      headerName: 'Sl No',
      field: 'id',
      width: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Odoo Id',
      field: 'odoo_partner_id',
      width: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Partner Name',
      field: 'name',
      flex: 1,
      sortable: true,
      filter: true,
      filterParams: { buttons: ['clear'] } as ITextFilterParams,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.2,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
      minWidth: 165,
    },
    {
      headerName: 'Partner Type',
      field: 'isVendorType',
      sortable: true,
      filter: true,
      cellRenderer: (params: any) =>
        params?.data?.isVendorRelate
          ? 'Vendor'
          : params?.data?.isCustomerRelate
          ? 'Customer'
          : '-',
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      minWidth: 120,
    },
    {
      headerName: 'Address',
      field: 'address',
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const d = params?.data
        return [d?.street_no, d?.street, d?.city, d?.state, d?.pin]
          .filter(Boolean)
          .join(', ')
      },
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      wrapText: true,
      minWidth: 150,
    },
    {
      headerName: 'Mobile',
      field: 'mobile_number',
      flex: 1,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 110,
    },
    {
      headerName: 'E-mail',
      field: 'email',
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      wrapText: true,
      minWidth: 160,
    },

    {
      headerName: 'GST No',
      field: 'gst',
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      minWidth: 150,
    },

    {
      headerName: 'PAN No.',
      field: 'pan',
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      minWidth: 110,
    },
    {
      headerName: 'Service',
      field: 'isLab',
      width: 120,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        if (params?.data?.isLab && params?.data?.isRadiology) {
          return `${lab}/${radiology}`
        } else if (params?.data?.isLab) {
          return lab
        } else if (params?.data?.isRadiology) {
          return radiology
        } else {
          return '-'
        }
      },
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      minWidth: 160,
    },
    {
      headerName: 'Location',
      field: 'isVendorType',
      width: 130,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.location ?? '-',
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
      minWidth: 120,
    },
    {
      headerName: 'Odoo Price List',
      field: 'priceList',
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 130,
    },
    {
      headerName: 'Created By',
      field: 'date_created',
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: RenderCreatedBy,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.4,
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 170,
    },
    {
      headerName: 'Updated By',
      field: 'date_changed',
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: RenderUpdatedBy,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.4,
        display: 'flex',
        alignItems: 'center',
      },
      minWidth: 165,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,
      sortable: false,
      filter: false,
      cellRenderer: renderEditActions,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      minWidth: 120,
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  ]
  useEffect(() => {
    getOrganizations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization])
  return (
    <>
      <Box className={classes?.partnerDasboardContainer}>
        <Box className={classes?.partnerDasboardTableContainer}>
          <MedAgDataGrid
            tableHeading='Partner'
            tableHeight={'100%'}
            rowData={filteredOrganizations}
            columnDefs={columnDefs}
            pagination={false}
            headerHeight={30}
            searchFieldWidth={200}
            searchField={false}
            loading={loading}
            filterActions={
              <>
                <select
                  onChange={(e) => setStatus(e.target.value)}
                  className={classes?.MedAgDataGridInput}
                  value={status}
                >
                  {activeOptions?.map((option: any) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>

                <TextField
                  placeholder='Search Orders'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={classes?.globalSearchInput}
                />
                <FilterActions />
              </>
            }
          />
        </Box>
        {deleteDialog && (
          <DeleteConfirmationDialog
            openDialog={deleteDialog}
            closeDialog={handleCloseDeleteDialog}
            data={organization}
            name={organization?.name}
            setData={setOrganizations}
            item={menuValues?.Partner}
          />
        )}
      </Box>
    </>
  )
}
export default Organization
